@if (publicFolder() === false) {
  <nb-icon class="private-folder" icon="lock-outline" pack="eva" data-cy="private-folder-badge"
           nbTooltip="Privat – nicht für Dienstleister und QR-Zugang sichtbar"></nb-icon>
}
